import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";
import { ReportCommentContext } from "..";
import { FlexColumn } from "../../../../../../Common/Styles";
import { reportCommentUtils } from "../utils";
import { Report } from "./Report";

export const ReportDetails = () => {
  const { typography } = useTheme();
  const { reportComment } = useContext(ReportCommentContext);
  const {
    why_reporting_answer,
    best_problem_description_answer,
    what_is_happening_answer,
  } = reportComment;
  const titles = reportCommentUtils.ReportCommentDescription;

  return (
    <FlexColumn $gapInPx={8}>
      <Components.Text
        text="Report details"
        style={{ tokenStyle: typography.Body.L }}
        fontWeight="font-weight-semibold"
      />
      <Report
        title={titles["why_reporting"]}
        description={why_reporting_answer}
      />
      <Report
        title={titles["best_problem_description"]}
        description={best_problem_description_answer}
      />
      <Report
        title={titles["what_is_happening"]}
        description={what_is_happening_answer}
      />
    </FlexColumn>
  );
};
